
import MenuIcon from '~/assets/icons/menu-secondary.svg';
import CloseIcon from '~/components/ui/icons/CloseIcon.vue';
import AddIcon from '~/components/ui/icons/AddIcon.vue';
import draggable from 'vuedraggable';
import Toggle from '~/components/ui/molecule/Toggle.vue';

export default {
  name: 'PollCreate',
  components: {
    MenuIcon,
    AddIcon,
    CloseIcon,
    draggable,
    Toggle,
  },
  data() {
    return {
      options: ['', ''],
      pollQuestion: '',
      maxOptions: 5,
      drag: false,
      isMultipleChoice: false,
    };
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost',
      };
    },
    // TODO from Julien: refactor this into a pure computed prop and handle
    canPostPoll() {
      const allOptionsValid = this.options.every(
        (option) => option.trim() !== ''
      );
      const questionValid = this.pollQuestion !== '';
      return allOptionsValid && questionValid;
    },
  },
  watch: {
    canPostPoll(canPost) {
      this.$emit('canPost', canPost);
    },
    options() {
      this.buildPollList();
    },
    pollQuestion() {
      this.buildPollList();
    },
    isMultipleChoice() {
      this.buildPollList();
    },
  },
  mounted() {
    this.$emit('canPost', this.canPostPoll);
  },
  methods: {
    addOption() {
      if (this.options.length < 5) {
        this.options.push('');
      }
    },
    removeOption(index) {
      this.options.splice(index, 1);
    },
    buildPollList() {
      const pollList = this.options.map((option, order) => ({
        title: this.pollQuestion,
        option,
        order,
        isMultipleChoice: this.isMultipleChoice,
      }));

      this.$emit('updatePollList', pollList);

      return pollList;
    },
  },
};
